import { useState } from "react";

import Lightbox from "./Lightbox";
import Button from "./Button";
import Checkbox from "./Checkbox";
import {
  GalleryPicker,
  TimelinePicker,
  TextAreaField,
  InputField,
  SelectField,
  useHotspotLightboxStyles,
} from "./HotspotOptionsLightbox";

const getOptions = (type, images) => {
  const options = [];
  let key = 1;

  if (type !== "pinned-video") {
    options.push({
      type: "input",
      placeholder: "Text for tooltip",
      label: "Tooltip",
      name: "tooltip",
      key: `option-${key++}`,
    });
    if (type !== "poi") {
      options.push({
        type: "checkbox",
        name: "permaTooltip",
        label: "Make permanently visible",
        key: `option-${key++}`,
      });
    }
  }

  switch (type) {
    case "note":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "Image URL",
          label: "Image URL (optional)",
          name: "image",
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Audio URL (optional)",
          name: "audio",
          key: `option-${key++}`,
        },
        {
          type: "textarea",
          placeholder: "Content of popup",
          label: "Content",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "video":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "video_type",
          label: "Video Type",
          options: [
            {
              label: "MP4 Video",
              value: "mp4",
            },
            {
              label: "Youtube Video",
              value: "youtube",
            },
            {
              label: "Vimeo Video",
              value: "vimeo",
            },
          ],
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Video URL",
          name: "url",
          key: `option-${key++}`,
        },
      );
      break;
    case "audio":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "audio_type",
          label: "Audio Type",
          options: [
            {
              label: "MP3 audio",
              value: "mp3",
            },
          ],
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Audio URL",
          name: "url",
          key: `option-${key++}`,
        },
        {
          type: "textarea",
          placeholder: "Content of popup",
          label: "Transcript (optional)",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "gallery":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "gallery",
          label: "Content",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "pinned-video":
      options.push({
        type: "input",
        placeholder: "URL of MP4",
        label: "Video URL",
        name: "url",
        key: `option-${key++}`,
      });
      break;
    case "web":
      options.push(
        {
          type: "input",
          placeholder: "URL of web page",
          label: "URL",
          name: "url",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "display",
          label: "Display Options",
          options: [
            {
              label: "New Tab",
              value: "tab",
            },
            {
              label: "Lightbox",
              value: "lightbox",
            },
          ],
          key: `option-${key++}`,
        },
      );
      break;
    case "poi":
      options.push(
        {
          type: "input",
          placeholder: "Name",
          label: "Name of Point of Interest",
          name: "name",
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "onEnter",
          label: "Look at automatically when entering scene",
          key: `option-${key++}`,
        },
      );
      break;
    case "timeline":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "timeline",
          label: "Scenes",
          name: "scenes",
          key: `option-${key++}`,
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
        },
      );
      break;
    default:
      break;
  }

  return options;
};

const HotspotRenameLightbox = ({
  show,
  hotspot,
  getOnChangeHandler,
  onComplete,
  onClose,
  images,
}) => {
  const classes = useHotspotLightboxStyles();
  const [expanded, setExpanded] = useState();

  const toggleMenu = () => setExpanded(x => !x);

  if (hotspot === null) {
    return null;
  }

  return (
    <Lightbox show={show} onClose={onClose}>
      <h3>{hotspot.type === "pinned-video" ? "Video" : "Hotspot"} Edit</h3>
      {getOptions(hotspot.type, images).map(item => {
        if (item.type === "input") {
          let formattingMethod = false;
          if (item.name === "tooltip" || item.name === "title") {
            formattingMethod = true;
          }
          let tooltipLabel = item.label;
          return (
            <InputField
              key={item.key}
              placeholder={item.placeholder}
              name={item.name}
              label={tooltipLabel}
              value={
                hotspot[item.name]
                  ? hotspot[item.name]
                  : hotspot.options[item.name]
              }
              onChange={getOnChangeHandler(item.name)}
              classes={classes}
              formattingMethod={formattingMethod}
            />
          );
        } else if (item.type === "select") {
          return (
            <SelectField
              key={item.key}
              name={item.name}
              label={item.label}
              options={item.options}
              value={
                hotspot[item.name]
                  ? hotspot[item.name]
                  : hotspot.options[item.name]
              }
              onChange={getOnChangeHandler(item.name)}
              classes={classes}
              expanded={expanded}
              toggle={toggleMenu}
            />
          );
        } else if (item.type === "gallery") {
          return (
            <GalleryPicker
              key={item.key}
              classes={classes}
              onChange={getOnChangeHandler(item.name)}
              value={hotspot.options.content}
              item={item}
            />
          );
        } else if (item.type === "timeline") {
          return (
            <TimelinePicker
              key={item.key}
              classes={classes}
              onChange={getOnChangeHandler(item.name)}
              name={item.name}
              scenes={hotspot.options.scenes}
              images={item.options}
            />
          );
        } else if (item.type === "textarea") {
          return (
            <TextAreaField
              key={item.key}
              placeholder={item.placeholder}
              name={item.name}
              label={item.label}
              value={
                hotspot[item.name]
                  ? hotspot[item.name]
                  : hotspot.options[item.name]
              }
              onChange={getOnChangeHandler(item.name)}
              classes={classes}
            />
          );
        } else if (item.type === "checkbox") {
          return (
            <Checkbox
              key={item.key}
              name={item.name}
              label={item.label}
              className={classes}
              value={
                (hotspot[item.name]
                  ? hotspot[item.name]
                  : hotspot.options[item.name]) ?? false
              }
              onChange={getOnChangeHandler(item.name)}
            />
          );
        } else {
          return null;
        }
      })}
      <Button onClick={() => onComplete()}>Save</Button>
    </Lightbox>
  );
};

export default HotspotRenameLightbox;
